import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  resetForm : FormGroup
  successMailSent = false
  mailSentMessage
  passwordError = false
  resetError
  resetCode
  constructor(private fb : FormBuilder, private authService : AuthService, private common : CommonService, private router : Router, private route : ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params:any) => {
      if(params.code){
        this.resetCode = params.code 
        console.log(this.resetCode)
        this.clearError()
        this.resetForm = this.fb.group({
          password: ['', Validators.required],
          passwordConfirmation: ['', Validators.required]
        })
      }
      else{
        this.router.navigateByUrl('/')
      }
    })
    
  }

  resetPassword(){
    this.common.showLoader()
    let value = this.resetForm.value
    this.clearError()
    if(value.password != value.passwordConfirmation){
      this.passwordError = true
      this.resetError = 'Passwords do not match'
      this.common.hideLoader()
    }
    else{
      value.code = this.resetCode
      this.authService.ResetPassword(value).subscribe((res:any)=>{
        this.common.hideLoader()
        if(res.jwt){
          this.successMailSent = true
          this.mailSentMessage = 'Reset successfully, please login again'
          this.resetForm.reset()
          setTimeout(() => {
            this.router.navigateByUrl('/')
          }, 1000);
        }
      }, (err:any) => {
        this.common.hideLoader()
        console.log(err)
      })
    }
  }

  clearError(){
    this.passwordError = false
    this.resetError = ''
    this.successMailSent = false
    this.mailSentMessage = ''
  }
}
